// extracted by mini-css-extract-plugin
module.exports = {"head":"ConfirmationModal_head__3wT4m","title":"ConfirmationModal_title__22Y0O","actions":"ConfirmationModal_actions__6KeiY"};